import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'AUTHOR',
  collections: {
    articlesIds: { get: 'articles' },
  },
});
